<template>
    <div>
        <Head :title="`${form.name}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('categories.index')"
            >
                Тарифи
            </Link>
            <span class="text-indigo-400 font-medium">/</span>
            {{ form.name }}
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <select-input v-model="form.lake_id" :error="form.errors.lake_id" class="pb-8 pr-6 w-full"
                                      label="Озеро">
                            <option :value="null"/>
                            <option v-for="lake in lakes" :key="lake.id" :value="lake.id">{{ lake.name }}</option>
                        </select-input>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Коефіцієнт ціни"/>
                        <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full"
                                        label="Опис"/>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button
                        class="text-red-600 hover:underline" tabindex="-1" type="button"
                        @click="destroy"
                    >
                        Видалити
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Оновити
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout.vue'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import TrashedMessage from '@/Shared/TrashedMessage.vue'
import DragAndDrop from "@/Shared/DragAndDrop.vue";
import TextareaInput from "@/Shared/TextareaInput.vue";

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        category: Object,
        lakes: Array
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                _method: 'put',
                name: this.category.name,
                description: this.category.description,
                price: this.category.price,
                lake_id: this.category.lake_id,
            }),
        }
    },
    methods: {
        update() {
            this.form.put(this.$route('categories.update',this.category.id))
        },
        destroy() {
            if (confirm(' Ви впевнені що хочете видалити тариф?')) {
                this.$inertia.delete(this.$route('categories.destroy',this.category.id))
            }
        }
    },
}
</script>
